// eslint-disable-next-line import/prefer-default-export
export const onChangeParent = ({ isChecked, rule, setAccessGroup }) => {
  if (!isChecked) {
    setAccessGroup((prev) => {
      return prev?.filter((item) => {
        return item?.id !== rule?.id;
      });
    });
  }
  if (isChecked) {
    const accessGroupItem = {
      id: rule?.id,
      slug: rule?.slug,
      description: rule?.description,
      name: rule?.name,
      rule_ids: rule?.rules?.data?.map((item) => {
        return item?.id;
      }),
    };
    setAccessGroup((current) => {
      return current.concat(accessGroupItem);
    });
  }
};
